import { render, staticRenderFns } from "./IsisTabs.vue?vue&type=template&id=826ebfe8&scoped=true&"
import script from "./IsisTabs.vue?vue&type=script&lang=js&"
export * from "./IsisTabs.vue?vue&type=script&lang=js&"
import style0 from "./IsisTabs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IsisTabs.vue?vue&type=style&index=1&id=826ebfe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826ebfe8",
  null
  
)

export default component.exports